import { render, staticRenderFns } from "./stadium_notice.vue?vue&type=template&id=97b40922&scoped=true&"
import script from "./stadium_notice.vue?vue&type=script&lang=ts&"
export * from "./stadium_notice.vue?vue&type=script&lang=ts&"
import style0 from "./stadium_notice.vue?vue&type=style&index=0&id=97b40922&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b40922",
  null
  
)

export default component.exports